class Product360Viewer {
  constructor(el) {
    this.el = el;
    this.stage = el.querySelector('.product-360-viewer__stage');
    this.frames = Array.from(el.querySelectorAll('.product-360-viewer__frame'));
    this.frameCount = this.frames.length;
    this.currentIndex = 0;
    this.isDragging = false;
    this.startX = 0;
    this.startIndex = 0;
    this.dragSensitivity = 4; // px de arrastre por cada frame

    this.isPlaying = false;
    this.playInterval = null;
    // Una vuelta completa dura ~4 segundos, sin importar cuántos frames tenga
    this.rotationDuration = 4000;

    this.scrubber = el.nextElementSibling;
    if (!this.scrubber || !this.scrubber.classList.contains('product-360-viewer__scrubber')) {
      this.scrubber = null;
    }

    this.playPauseBtn = el.querySelector('.product-360-viewer__play-pause');
    this.iconPlay = this.playPauseBtn ? this.playPauseBtn.querySelector('.icon-play') : null;
    this.iconPause = this.playPauseBtn ? this.playPauseBtn.querySelector('.icon-pause') : null;

    if (this.frameCount < 2) return;

    this.bindEvents();
  }

  bindEvents() {
    this.el.addEventListener('mousedown', this.onDragStart.bind(this));
    window.addEventListener('mousemove', this.onDragMove.bind(this));
    window.addEventListener('mouseup', this.onDragEnd.bind(this));

    this.el.addEventListener('touchstart', this.onDragStart.bind(this), { passive: true });
    window.addEventListener('touchmove', this.onDragMove.bind(this), { passive: true });
    window.addEventListener('touchend', this.onDragEnd.bind(this));

    this.el.addEventListener('dragstart', (e) => e.preventDefault());

    if (this.scrubber) {
      this.scrubber.addEventListener('input', (e) => {
        this.stopAutoRotate();
        this.el.classList.add('has-interacted');
        this.setFrame(parseInt(e.target.value, 10));
      });
    }

    if (this.playPauseBtn) {
      this.playPauseBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (this.isPlaying) {
          this.stopAutoRotate();
        } else {
          this.startAutoRotate();
        }
      });
    }
  }

  getClientX(e) {
    return e.touches ? e.touches[0].clientX : e.clientX;
  }

  onDragStart(e) {
    // Si el click viene de un botón de los controles, no lo tratamos como arrastre
    if (e.target.closest('.product-360-viewer__controls')) return;

    this.stopAutoRotate();
    this.isDragging = true;
    this.startX = this.getClientX(e);
    this.startIndex = this.currentIndex;
    this.el.classList.add('has-interacted');
  }

  onDragMove(e) {
    if (!this.isDragging) return;
    const deltaX = this.getClientX(e) - this.startX;
    const frameDelta = Math.round(deltaX / this.dragSensitivity);
    let newIndex = (this.startIndex - frameDelta) % this.frameCount;
    if (newIndex < 0) newIndex += this.frameCount;
    this.setFrame(newIndex);
  }

  onDragEnd() {
    this.isDragging = false;
  }

  setFrame(index) {
    if (index === this.currentIndex) return;
    this.frames[this.currentIndex].classList.remove('is-active');
    this.frames[index].classList.add('is-active');
    this.currentIndex = index;
    if (this.scrubber) {
      this.scrubber.value = index;
    }
  }

  startAutoRotate() {
    this.isPlaying = true;
    this.el.classList.add('has-interacted');
    this.togglePlayIcon(true);
    const intervalMs = this.rotationDuration / this.frameCount;
    this.playInterval = setInterval(() => {
      let next = (this.currentIndex + 1) % this.frameCount;
      this.setFrame(next);
    }, intervalMs);
  }

  stopAutoRotate() {
    if (this.playInterval) {
      clearInterval(this.playInterval);
      this.playInterval = null;
    }
    this.isPlaying = false;
    this.togglePlayIcon(false);
  }

  togglePlayIcon(isPlaying) {
    if (!this.iconPlay || !this.iconPause) return;
    this.iconPlay.style.display = isPlaying ? 'none' : '';
    this.iconPause.style.display = isPlaying ? '' : 'none';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-360-viewer').forEach((el) => {
    new Product360Viewer(el);
  });
});